"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturedTournamentZone = exports.TopTournamentZone = void 0;
var TopTournamentZone;
(function (TopTournamentZone) {
    TopTournamentZone["ClassicLeft"] = "classic_left";
    TopTournamentZone["EsportLeft"] = "esport_left";
    TopTournamentZone["MixLeft"] = "mix_left";
})(TopTournamentZone = exports.TopTournamentZone || (exports.TopTournamentZone = {}));
var FeaturedTournamentZone;
(function (FeaturedTournamentZone) {
    FeaturedTournamentZone["MixLeftWeb"] = "mix-left-web";
    FeaturedTournamentZone["EsportLeftWeb"] = "esport-left-web";
    FeaturedTournamentZone["ClassicLeftWeb"] = "classic-left-web";
    FeaturedTournamentZone["MixTopIos"] = "mix-top-ios";
    FeaturedTournamentZone["EsportTopIos"] = "esport-top-ios";
    FeaturedTournamentZone["ClassicTopIos"] = "classic-top-ios";
})(FeaturedTournamentZone = exports.FeaturedTournamentZone || (exports.FeaturedTournamentZone = {}));
//# sourceMappingURL=topTournamentZones.js.map